import AxiosHttpClient from 'app/api/AxiosHttpClient';
import { AuthenticationService } from 'app/auth/AuthenticationService';
import { TokenRequest } from 'app/auth/TokenRequest';
import { TokenResponse } from 'app/auth/TokenResponse';
import TokenStore from 'app/auth/SessionStorageTokenStore';
import { TokenInformation } from 'app/auth/TokenInformation';

const TOKEN_PATH = '/token';

/**
 * Сервис аутентификации в МСИ. Позволяет обменять код МСИ на jwt токен авторизации.
 */
export class MsiAuthenticationService
    implements AuthenticationService<TokenRequest, void> {
    private apiClient = new AxiosHttpClient();

    /**
     * Запрос jwt токена авторизации.
     */
    async getToken(request: TokenRequest): Promise<void> {
        const data = (await this.apiClient.executeTokenRequest(
            TOKEN_PATH,
            request,
        )) as TokenResponse;
        TokenStore.tokenInformation = TokenInformation.deserialize(data);
    }
}
